const registerCuiModalTrigger = (selectors: string) => {
  document.addEventListener("click", (e: MouseEvent) => {
    const element = (e.target as HTMLElement).closest(selectors) as HTMLElement | null;
    if (element) {
      e.preventDefault();
      openModalByElement(element);
    }
  });
};

const openModalByElement = (el: HTMLElement) => {
  const modal = getModalByElement(el);
  modal.open();
};

const getModalByElement = (el: HTMLElement) => {
  const contentLoaderContainer = document.querySelector(
    `content-loader-container[page-path="${el.getAttribute("href")}"]`
  );
  if (contentLoaderContainer) {
    return contentLoaderContainer.closest("cui-modal") as HTMLCuiModalElement;
  }
  return createModal(el);
};

const createModal = (el: HTMLElement) => {
  const modal = document.createElement("cui-modal");
  modal.setAttribute("headline", el.getAttribute("title") || "");
  modal.innerHTML = `<content-loader-container page-path="${el.getAttribute(
    "href"
  )}" />`;
  document.body.appendChild(modal);
  return modal;
};

export default function () {
  const SELECTOR = '[data-cui-trigger="modal"]';
  const SELECTOR_LEGACY = ".modal-link"; // Support for legacy modal links which are used in TYPO3

  registerCuiModalTrigger([SELECTOR, SELECTOR_LEGACY].join(", "));
}
